import { SelectionAlbum, SelectionPhoto } from "../../types/selection/selection";
import UploadSelectionProvider from "./UploadSelectionProvider";

export default class MobileUploadSelectionProvider extends UploadSelectionProvider {
  albums: {
    data: SelectionAlbum[];
  };
  albumPhotos: {
    [albumRef: string]: {
      data: SelectionPhoto[];
      paging?: number;
    };
  };

  constructor() {
    super();

    this.providerTag = "mobile_upload";

    this.albums = { data: [] };
    this.albumPhotos = {};
  }
}
